import { render, staticRenderFns } from "./UpdateNewsletterSubscription.vue?vue&type=template&id=59737a65"
import script from "./UpdateNewsletterSubscription.vue?vue&type=script&lang=js"
export * from "./UpdateNewsletterSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports